import { useNavigate } from 'react-router-dom'
import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { useTranslation } from 'react-i18next'
import { useEmitEvent } from '../../../../hooks/analytics/useEmitEvent'
import { TrackingEvents } from '@estercare/ester-shared'

export const ScreeningStandardCompleted = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const emitEvent = useEmitEvent()

  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.standardCompletedTitle')}
      screeningTitle={t('employee.screening.standardCompletedTitle')}
      screeningDescription={t('employee.screening.standardCompletedDescription')}
      buttonText={t('employee.screening.standardCompletedButton')}
      onButtonClick={() => {
        navigate('/portal/your-health/health-plan')
        emitEvent({
          eventType: TrackingEvents.CLICK,
          action: 'standard_completed_navigate_to_health_plan',
        })
      }}
    />
  )
}
